<script setup>
  import {inject, onBeforeUnmount, ref} from "vue";

  import {usePage} from "@inertiajs/vue3";
  import {MedButton, MedSpinner} from "@pharma4u/medicheck-components";

  import {useAuthHttp} from "@/resources/js/Composable/useAuthHttp.js";

  defineOptions({
    name: "RecordComponentJsonExporter",
  });

  const privacy = inject("$privacy");
  const page = usePage();

  const loading = ref(false);
  let activeExport = null;

  const exportAsJson = async () => {
    loading.value = true;

    const decryptedPatient = await privacy.decryptPatient(page.props.patient);
    const now = new Date();
    const birthdate = new Date(decryptedPatient.birthdate);
    let age = now.getFullYear() - birthdate.getFullYear();
    const m = now.getMonth() - birthdate.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < birthdate.getDate())) {
      age--;
    }

    if (activeExport) {
      activeExport.cancel();
    }

    const exportRequest = useAuthHttp({age: age});
    activeExport = exportRequest;

    exportRequest
      .post(
        route("api.records.json-export", {
          patient: page.props.patient.id,
          record: page.props.record.id,
        }),
      )
      .then((response) => {
        downloadObjectAsJson(response, "medicheck_export_" + Date.now());
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const downloadObjectAsJson = (exportObject, exportName) => {
    // https://stackoverflow.com/questions/19721439/download-json-object-as-a-file-from-browser
    const dataString = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObject));
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataString);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.append(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  onBeforeUnmount(() => {
    if (activeExport) {
      activeExport.cancel();
    }
  });
</script>

<template>
  <MedButton :disabled="loading" :data-test="getTestId('json-export-button')" @click="exportAsJson">
    <template #before>
      <MedSpinner v-if="loading" :data-test="getTestId('json-export-spinner')" />
    </template>
    Analyse im JSON-Format herunterladen
  </MedButton>
</template>
